import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlesson3dPrinting } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const ThreeDPrinting = () => {
  const dispatch = useDispatch();
  const { model3DPrintingList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlesson3dPrinting());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"3D Printing"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "3D Printing",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={model3DPrintingList} />

        <Footer />
      </div>
    </>
  );
};

export default ThreeDPrinting;
